// removed by extract-text-webpack-plugin
module.exports = {"marketsTable":"_18Tr58i5i2LtuTUg3LoZZY","container":"_3ZuLThNeB0Ze56QRbvttlH","marketRow":"_23Mv5hXR_4SmGVUm1frHk9","marketsData":"_2r4BXR7M2feSUMITT9OSY-","market":"_37ZHoXvvUzjXrKFMhcNn5k","price":"_3A0P7tR9ztFWp4jT4_Ze6Z","variation":"_17L1fZmQm3NvO520LAxec2"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Header/Mobile/styles.css
// module id = 1597
// module chunks = 83